export default {
    categories: [],
    specialistsLoading: false,
    specialists: [],
    selectedCategoryId: null,
}
